import { render, staticRenderFns } from "./bxDcOrderConf.vue?vue&type=template&id=a110348e&scoped=true&"
import script from "./bxDcOrderConf.vue?vue&type=script&lang=js&"
export * from "./bxDcOrderConf.vue?vue&type=script&lang=js&"
import style0 from "./bxDcOrderConf.vue?vue&type=style&index=0&id=a110348e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a110348e",
  null
  
)

export default component.exports